import React, { useEffect, useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Table, Button, Widget, MasterDetailForm } from '@digital/ui';

import { getProcessadosList } from '@app/api/RegraSubstituto';

interface ModalListaAlteracoesProps {
    id: string;
}

const ModalListaAlteracoes = (props: ModalListaAlteracoesProps) => {
    const { id } = props;
    const [openModal, setOpenModal] = useState(false);
    const [alteracoes, setAlteracoes] = useState([]);

    useEffect(() => {
        if (openModal) {
            getProcessadosList(id).then(data => setAlteracoes(data));
        }
    }, [openModal]);

    const columns = [
        {
            title: 'Local Alteração',
            dataIndex: 'localAlteracao',
        },
        {
            title: 'Alteração',
            dataIndex: 'nomeAlteracao',
        },
    ];

    return (
        <>
            <Tooltip title="Comentários">
                <Button
                    onClick={() => {
                        setOpenModal(true);
                    }}
                    icon="messaging-comments"
                />
            </Tooltip>
            <Modal
                title="Alterações Aplicadas pela Regra"
                visible={openModal}
                onCancel={() => {
                    setOpenModal(false);
                }}
                footer={null}
            >
                <MasterDetailForm>
                    <Widget>
                        <Table columns={columns} dataSource={alteracoes} pagination={false}></Table>
                    </Widget>
                </MasterDetailForm>

            </Modal>
        </>
    );
};

export default ModalListaAlteracoes;